import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app-notifications-container" }

import { computed } from 'vue'
import { useNotification } from '@/composables/useNotification'
import AppNotificationItem from "@/components/ui-kit/notifications/AppNotificationItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNotificationContainer',
  setup(__props) {

const notificationService = useNotification()
const notifications = computed(() => notificationService.notifications.value)

const handleClose = (id: number) => {
	notificationService.remove(id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "notification-slide" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (notification) => {
          return (_openBlock(), _createBlock(AppNotificationItem, {
            key: notification.id,
            notification: notification,
            onClose: handleClose
          }, null, 8, ["notification"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})